
import Vue from "vue";
import {ISelectItem} from "winfakt-vue-components";
import {TicketStatus} from "../../utils/ticket-status";

export default Vue.extend({
	props: {
		value: {
			type: [Number as () => TicketStatus, Array as ()=>TicketStatus[]]
		},
		label: String,
		fancy: Boolean,
		multi: Boolean
	},
	computed: {
		items(): ISelectItem<TicketStatus>[] {
			return [
				{
					text: "Open",
					value: TicketStatus.Open
				},
				{
					text: "Afgehandeld",
					value: TicketStatus.Handled
				},
				{
					text: "Actie vereist",
					value: TicketStatus.ActionRequired
				},
				{
					text: "Slapend",
					value: TicketStatus.Sleep
				},
				{
					text: "Gesloten door klant",
					value: TicketStatus.Closed
				},
				{
					text: "Wacht op update",
					value: TicketStatus.WaitForUpdate
				},
				{
					text: "Nog te testen",
					value: TicketStatus.ToTest
				},
				{
					text: "In ontwikkeling",
					value: TicketStatus.InDevelopment
				},
				{
					text: "Wishlist",
					value: TicketStatus.WishList
				}
			];
		},
	},
	methods: {
		onValue(event: TicketStatus | TicketStatus[]) {
			this.$emit("input", event);
		}
	}
});
